<template>
  <v-snackbar v-model="visible" :timeout="(persistent)?-1:timeout" :color="color" :light="light" @input="$emit('input',visible)" top>
    <div v-html="text" class="text-center"></div>
    <template v-slot:action="{ attrs }">
          <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="onClick"
          >
            {{actionText}}
          </v-btn>
          <span v-if="!_.isEmpty(actionCancelText)">|</span>
          <v-btn
            v-if="!_.isEmpty(actionCancelText)"
            color="white"
            text
            v-bind="attrs"
            @click="onCancelClick"
          >
            {{actionCancelText}}
          </v-btn>
    </template>
    <v-progress-linear
      absolute
      bottom
      color="grey"
      :value="Math.floor(100 * (currentTime / timeout))"
    />
  </v-snackbar>
</template>

<script>
  export default {
    props:{
      actionText:{
        type:String,
        default:'OK'
      },
      actionCancelText:{
        ype:String,
        default:''
      },
      text:{
        type:String
      },
      color:{
        type:String,
        default:undefined
      },
      value:{
        type:Boolean,
        default:false
      },
      light:{
        type:Boolean,
        default:false
      },
      persistent:{
        type:Boolean,
        default:false
      },
      timeout:{
        type:Number,
        default:5000
      },
      timeoutStart:{
        type:Number,
        default:0
      }
      
    },
    watch:{
      value(val){
        this.visible=val;
        if(val){
          this.syncPbar();
        }
      }
    },
    data: () => ({
      visible:false,
      mode: '',
      currentTime: 0,
      progessPointer:null
    }),
    methods:{
      onClick(){
        //this.visible = false;
        this.$emit('input',false);
        this.$emit('click');
        this.stopSyncPbar();
      },
      onCancelClick(){
        this.$emit('input',false);
        this.$emit('cancel');
        this.stopSyncPbar();
      },
      syncPbar() {
        //TODO delta (zeitstempel) übergeben und hier als 0 setzen 
        // +1h
        this.stopSyncPbar();
        let startTime= new Date().getTime()-this.timeoutStart;
        this.progessPointer=setInterval(() => {
          this.currentTime= (new Date().getTime() - startTime);
          //console.log(this.currentTime+' - '+this.timeout+ ' => '+(this.currentTime>this.timeout));
          if(this.currentTime>this.timeout){
            console.log('Send outoftime');
            this.stopSyncPbar();
            this.$emit('outoftime');
          }
        }, 10);
      },
      stopSyncPbar(){
        if(this.progessPointer!=null){
          clearInterval(this.progessPointer);
          this.progessPointer=null;
        }
        this.currentTime = 0;
      },
      show(){

      }
    }
  }
</script>
